import { NavItem } from './nav-item';

export class DefaultNavItem extends NavItem {}
